import { render, staticRenderFns } from "./inspection_task.vue?vue&type=template&id=390e9310&scoped=true"
import script from "./inspection_task.vue?vue&type=script&lang=js"
export * from "./inspection_task.vue?vue&type=script&lang=js"
import style0 from "./inspection_task.vue?vue&type=style&index=0&id=390e9310&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390e9310",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390e9310')) {
      api.createRecord('390e9310', component.options)
    } else {
      api.reload('390e9310', component.options)
    }
    module.hot.accept("./inspection_task.vue?vue&type=template&id=390e9310&scoped=true", function () {
      api.rerender('390e9310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/inspection/inspection_task.vue"
export default component.exports